import React from "react";

export interface FilterTabItem<T extends string = string> {
    key: T;
    label: string;
    count?: number;
}

interface MobileFilterTabsProps<T extends string = string> {
    tabs: FilterTabItem<T>[];
    activeTab: T;
    onChange: (key: T) => void;
    className?: string;
    scrollable?: boolean;
}

function MobileFilterTabs<T extends string>({
    tabs,
    activeTab,
    onChange,
    className = "",
    scrollable = false,
}: MobileFilterTabsProps<T>) {
    return (
        <div
            className={`w-full flex align-items-center gap-2 pt-2 pb-1 ${scrollable ? "overflow-x-auto" : ""} ${className}`}
            style={scrollable ? { scrollbarWidth: "none", overscrollBehaviorX: "contain" }: undefined}
        >
            {tabs.map((tab) => {
                const isActive = activeTab === tab.key;

                return (
                    <button
                        key={tab.key}
                        type="button"
                        onClick={() => onChange(tab.key)}
                        className={`${scrollable ? "flex-shrink-0 px-3" : "flex-1 px-1"} flex align-items-center justify-content-center gap-1 border-none cursor-pointer py-2 text-xs font-semibold transition-all transition-duration-200`}
                        style={{
                            borderRadius: "8px",
                            backgroundColor: isActive ? "#EBF3FC" : "#F1F5F9",
                            color: isActive ? "#0084D1" : "#64748B",
                            border: isActive ? "1px solid #BFDBFE" : "1px solid transparent",
                        }}
                    >
                        <span className="white-space-nowrap">{tab.label}</span>
                        {tab.count !== undefined && (
                            <span
                                style={{
                                    borderRadius: "4px",
                                    fontSize: "0.65rem",
                                    padding: "1px 5px",
                                    backgroundColor: isActive ? "#0084D1" : "#E2E8F0",
                                    color: isActive ? "#FFFFFF" : "#475569",
                                    fontWeight: 700,
                                }}
                            >
                                {tab.count}
                            </span>
                        )}
                    </button>
                );
            })}
        </div>
    );
}

export default MobileFilterTabs;